<template>
	<div class="check-in">
		<div class="check-in__title">
			<img id="logo" alt="Showcase Check In" src="../images/logo.png" class="check-in__logo">
		</div>
		<scanner
			@scanned="scanned"
			:logs="logs"
			:showingMember="member"
			:forceReload="forceReload"
		></scanner>

		<div class="check-in__container">

			<button @click="reset" class="reset-close" v-if="member || error">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
					<path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
				</svg>

			</button>

			<div class="check-in__ready" v-if="!error && !member">
				<span>Start by scanning a user's barcode</span>
			</div>

			<div class="check-in__error" v-if="error">
				<span>{{ error }}</span>
			</div>

			<div v-if="member" class="check-in__success">
				<span class="check-in__message" v-if="member.checked_in">Checked <em>{{ member.name }}</em> <br>
					into <em>{{ member.event_name}}</em></span>
				<table class="check-in__table">
					<tr>
						<td>Member ID:</td>
						<td>{{ member.member_id }}</td>
					</tr>
					<tr>
						<td>Member's Full Name:</td>
						<td>{{member.name}}</td>
					</tr>
					<tr>
						<td>Member's Email:</td>
						<td>{{ member.email }}</td>
					</tr>
					<tr>
						<td>Member's Tier:</td>
						<td>{{member.tier}}</td>
					</tr>
				</table>
			</div>

			<booking-button class="button check-in__button" v-if="bookings.length" v-for="(booking, index) in bookings" :booking="booking" :key="index" @click="checkIn(booking)"></booking-button>
			<button class="button check-in__button" :disabled="!member && !error" @click="reset" v-if="!canCheckIn">OK</button>
			<small style="position: absolute; bottom: 1px; right: 1px;">v1.3.1</small>
		</div>
		<div class="check-in__loading" v-if="loading"></div>
	</div>
</template>

<script>
	import Scanner from './ScannerComponent';
	import BookingButton from './BookingButtonComponent';
	import Axios from 'axios';

	export default {
		name: "CheckInComponent",

		components: {
			Scanner,
			BookingButton
		},

		data: function () {
			return {
				loading: true,
				code: null,
				member: null,
				error: null,
				debug: false,
				logs: [],
				endpoint: null,
				forceReload: 0,
			};
		},

		computed: {
			bookings: function () {
				if (!this.member || !this.member.bookings) {
					return [];
				}

				return this.member.bookings;
			},

			canCheckIn: function () {
				const bookings = this.bookings.filter(booking => {
					return !booking.checked_in;
				})

				return bookings.length > 0;
			}
		},


		mounted: function () {
			window.scrollTo(0,1)
			this.loading = false;
			this.setEndpoint();
		},

		methods: {
			setEndpoint () {
				this.endpoint = 'https://www.showcase.co/wp-admin/admin-ajax.php';
			},

			info: function (success, label, item = null) {
				if (!this.debug && !success) {
					window.bugsnagObj.notify({
						message: label,
						data: item,
					});
					return;
				}

				if (typeof item === 'string' || item instanceof String) {
					this.logs.push(item);
				} else {
					this.logs.push(JSON.stringify(item));
				}
			},

			scanned (result) {
				this.reset();
				this.loading = true;
				this.code = result.text;
				this.getBookings();
			},

			reset () {
				if(this.member === null) {
					this.forceReload++;
				}

				this.code = null;
				this.member = null;
				this.error = null;
				
			},

			getBookings () {
				let self = this;

				Axios.get(this.endpoint, {
					params: {
						action: 'app_get_bookings',
						member_id: this.code,
					},
				}).then(res => {
					if (res.data) {
						this.info(true, 'Received member bookings', {
							member_id: this.code,
							res: res.data
						});
					} else {
						this.info(false, 'Failed to get member bookings', {
							member_id: this.code,
							err: res
						});
					}

					this.member = res.data;

					if (!this.canCheckIn) {
						this.error = 'There are no events for the Member to check-in to';
					}
				}).catch((err) => {

					setTimeout(() => {
						this.forceReload++;
					}, 1000);

					if (typeof err.response === 'undefined') {
						this.error = 'Something went wrong, try again'
						return;
					}

					if (typeof err.response.data.error !== 'undefined') {
						this.error = err.response.data.error;
					} else {
						this.error = 'Something went wrong, try again'
					}
					
					self.info(false, 'Failed to get member bookings', {
						member_id: this.code,
						err: err
					});
				}).then(() => {
					this.loading = false;
				});
			},

			checkIn (booking) {
				let self = this;

				Axios.get(this.endpoint, {
					params: {
						action: 'app_check_in',
						booking_id: booking.id,
					}
				}).then(res => {
					if (res.data.error && res.data.error !== 'Already checked in') {
						this.error = res.data.error;

						this.info(false, 'Failed to checkin member', {
							member_id: this.code,
							booking_id: booking.id,
							res: res,
						});

						return;
					}

					this.info(true, 'Checked in member', {
						member_id: this.code,
						booking_id: booking.id,
						err: res,
					});

					this.member = res.data;
					this.$forceUpdate();

				}).catch(err => {
					self.info(true, 'Something went wrong checking in member', {
						member_id: this.code,
						booking_id: booking.id,
						err: err,
					});

					if (typeof err.response === 'undefined') {
						this.error = 'Something went wrong, try again'
						return;
					}

					if (typeof err.response.data.error !== 'undefined') {
						this.error = err.response.data.error;
					} else {
						this.error = 'Something went wrong, try again'
					}

				}).then(() => {
					this.loading = false;

					window.setTimeout(() => {
						this.reset();
					}, 10000);
				});
			},
		}
	}
</script>

<style scoped lang="scss">
	.check-in {
		text-align: center;
		display: flex;
		flex-direction: column;
		height: 100vh;
		margin: 0 auto;
		position: relative;

		&__title {
			font-weight: normal;
			position: fixed;
			z-index: 200;
			background-color: #000;
			background: rgba(0, 0, 0, .9);
			padding: 20px;
			margin-top: 0;
			width: 100%;
			width: calc(100% - 100px);
			left: 0;

		}

		&__logo {
			max-width: 100%;
			width: 400px;
			margin: 0 auto;
		}

		&__container {
			position: fixed;
			bottom: 0;
			left: 0;
			background: #000;
			background: rgba(0, 0, 0, .9);
			z-index: 200;
			right: 0;
			padding: 30px 20px 20px;
		}

		&__ready {
			font-size: 18px;
			margin: 10px 0;
		}

		&__error {
			color: #E12500;
			font-size: 18px;
			margin: 10px 0;
		}

		&__success {
			margin: 10px 0;
		}

		&__button {
			margin-top: auto !important;
		}

		&__table {
			width: 100%;
			margin: 10px 0;

			td {
				text-align: left;
				padding: 3px;
			}

			td:first-of-type {
				font-weight: bold;
				color: #ceb992;
			}
		}

		&__message {
			font-size: 18px;
			color: #ceb992;

			em {
				color: #ffffff;
			}
		}

		&__loading {
			background-color: rgba(0, 0, 0, .5);
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 1000;
			background-image: url("../images/loading.svg");
			background-repeat: no-repeat;
			background-position: center;
			background-size: 200px;
		}

		.reset-close {
			background: none;
			border: none;
			color: #fff;
			position: absolute;
			top: 10px;
			right: 10px;
			svg {
				width: 28px;
				height: 28px;
			}

		}
	}
</style>


// WEBPACK FOOTER //
// src/components/CheckInComponent.vue